module.exports = __webpack_public_path__ + "static/media/twitter_full.a01ab72bfa959a1961d5eb2f1c047d07.svg";